import { uniq } from 'lodash';
import type { MenuItem } from '../types/menuItem';

export const nestItems = <T extends MenuItem[]>(items: T, path = ''): MenuItem[] => {
  const rootKeys = uniq(
    items.map((item) => {
      const match = item.name.replace(`^(${path ? path + '\\.' : ''}`, '').match(/^[^.]+?(?=$|\.)/);

      if (match === null) {
        return item.name;
      }

      return match[0];
    }),
  );

  return rootKeys
    .flatMap((key) => {
      const item = items.find((item) => item.name === key);
      const children = items.filter((item) => item.name.startsWith(`${key}.`));

      if (!item) {
        return children;
      }

      return {
        ...item,
        items: children,
      };
    })
    .sort((a, b) => a.order - b.order);
};
